import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
  ko: {
    translation: {
      app_name: 'Kaching',
      welcome: '환영합니다',
      dashboard: '대시보드',
      predictions: '매출 예측',
      risk: '위험도',
      actions: '액션',
      intelligence: '집단 지능',
      stability: '안정성',
      kpi: 'KPI',
      wholesale: '도매',
      settings: '설정',
    },
  },
  en: {
    translation: {
      app_name: 'Kaching',
      welcome: 'Welcome',
      dashboard: 'Dashboard',
      predictions: 'Predictions',
      risk: 'Risk',
      actions: 'Actions',
      intelligence: 'Intelligence',
      stability: 'Stability',
      kpi: 'KPI',
      wholesale: 'Wholesale',
      settings: 'Settings',
    },
  },
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ko',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n

